export default __webpack_public_path__ + "static/media/02.b556cc70.png";